module.exports = __webpack_public_path__ + "static/media/down-chevron.53c4e457.svg";